// Keep exploration settings until an explicit reset or page reload.
export class ExperimentSession {
 constructor(settings,id){this.settings=settings;this.id=id;this.saved=new Map();}
 defaults(id){return {values:Object.fromEntries(this.settings[id].map(([key,,,,value])=>[key,value])),effect:true};}
 get state(){const state=this.saved.get(this.id)||this.defaults(this.id);return {values:{...state.values},effect:state.effect};}
 select(id){if(id===this.id)return false;this.id=id;return true;}
 setValue(key,value){const state=this.state;state.values[key]=value;this.saved.set(this.id,state);}
 setEffect(effect){this.saved.set(this.id,{...this.state,effect});}
 reset(){this.saved.delete(this.id);}
}
